import ship from './ship'
import contract from './contract'
import container from './container'
import box from './box'
import boxes from './boxes'
import warehouse from './warehouse'
import plane from './plane'
import clipboard from './clipboard'
import grs from './grs'
import multimodal from './multimodal'
import train from './train'
import truck from './truck'

export default [
  ship,
  contract,
  container,
  boxes,
  box,
  warehouse,
  plane,
  clipboard,
  grs,
  multimodal,
  train,
  truck
]



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/index.js